import React from 'react';

import { Icon } from '@iconify/react';
import { Card } from 'react-bootstrap';

import ToolTip from '../Common/Tooltip';
import EditableField from './EditableField';
class Header extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <Card.Header className='card-height-50'>
        <Card.Title>
          <div className={`d-flex justify-content-between ${this.props.className}`}>
            <div className="d-flex justify-content-start col-md-9 pl-0 text-ellipsis">
              <h5 className='col-sm-8'>
                <b className={this.props.showBackButton ? 'header-icon-label' : ''}>{this.props.editMode ? <EditableField handleChange={(name) => this.props.handleChange(name)} value={this.props.title}></EditableField> : this.props.title}</b>
                {this.props.componentSelected ? (
                  <>
                    <i className="feather icon-chevrons-right" />
                    <span>
                      <b>{this.props.selectedComponentName}</b>
                    </span>
                  </>
                ) : null}
              </h5>
            </div>
            <div className={`d-flex ${this.props.iconPosition || ``} col-md-3`}>
              {this.props.iconProps && this.props.iconProps.map((icon, index) => {
                return (
                  (icon.showIcon &&
                    <div key={index} className={`ml-2 cursor-${icon.cursor}`}>
                      <ToolTip
                        toolTipKEy={icon.toolTipKEy}
                        toolTipValue={icon.toolTipValue}
                        overlayComponent={
                          !icon.customIcon ?
                            <span onClick={icon.onClickHandler}>
                              <i className={icon.icon} style={{ color: `${icon.color}` }} />
                            </span>
                            :
                            <span>
                              <Icon onClick={icon.onClickHandler} rotate={icon.rotate} icon={icon.icon} color={icon.color} width={icon.width} height={icon.icon} style={icon.style} />
                            </span>
                        }
                      >
                      </ToolTip>
                    </div>
                  )
                )
              })}
            </div>
          </div>
        </Card.Title>
      </Card.Header>
    );
  }
}

export default Header;
